import * as React from 'react';

export const TaLoaderPage = () => {
	return (
		<div className='ta-loader-container'>
			<div className='ta-loader'>
				<div />
				<div />
				<div />
				<div />
			</div>
		</div>
	);
};
